import React from "react";
import {
  BodyStyle,
  LabelStyle,
  Wrap,
  RequiredStyle,
  FooterStyle,
} from "./styles";

interface FieldProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  required?: boolean;
  hint?: React.ReactNode;
}

const Field = ({ label, required, hint, children, ...rest }: FieldProps) => {
  return (
    <Wrap {...rest}>
      <LabelStyle>
        {label} {required && <RequiredStyle>*</RequiredStyle>}
      </LabelStyle>
      <BodyStyle>{children}</BodyStyle>
      {hint && <FooterStyle>{hint}</FooterStyle>}
    </Wrap>
  );
};

export default Field;
